<template>
  <form-field-select
    label="Pipeline View"
    class="flex-grow"
    v-model="activePipelineView"
  >
    <option
      v-for="pipeline in pipelineViews"
      :value="pipeline.id"
      :key="pipeline.id"
    >{{ pipeline.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "PipelineViews",
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    pipelineViews() {
      return [
        {id: null, label: "All Statuses"},
        ...this.$store.getters["pipeline/pipelineViews"]
      ];
    },
    activePipelineView: {
      get() {
        let view = this.$store.getters["activePipelineView/activePipelineView"];
        if (view) return view.id;
        return null;
      },
      set(pipelineViewId) {
        this.$store.dispatch("activePipelineView/setup", pipelineViewId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {

  .field {
    margin-left: -2px;
  }
}
</style>
